export const REQUEST = 'REQUEST';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const UPDATE_DATA_SUCCESS = 'UPDATE_DATA_SUCCESS';
export const REQUEST_FAILURE_EMPTY_SET = 'REQUEST_FAILURE_EMPTY_SET';
export const UPDATE_KEY = 'UPDATE_KEY';
export const ADD_DATA_SUCCESS = 'ADD_DATA_SUCCESS';
export const DELETE_DATA_SUCCESS = 'DELETE_DATA_SUCCESS';
export const DELETE_DATA_BULK_SUCCESS = 'DELETE_DATA_BULK_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';

export const START_INITIALISE = 'START_INITIALISE';
export const INITIALISE_SUCCESS = 'INITIALISE_SUCCESS';

export const START_LOAD_DATA = 'START_LOAD_DATA';
export const FINISH_LOAD_DATA = 'FINISH_LOAD_DATA';
